import { AccommodationPlaceFragment, AccommodationPlaceType } from '@graphql/generated';
import { AccommodationCombined, AccommodationCombinedType, HasFavoriteProperty, HasIdProperty, ReservedRoomBlock } from './accommodation.types';

export const RoomBlockToAccommodationCombined = (rooomBlock: ReservedRoomBlock) => {
  return {
    id: rooomBlock.id,
    type: AccommodationCombinedType.Roomblock,

    //   General Information
    displayName: rooomBlock.displayName,
    address: rooomBlock.address,
    city: undefined,
    country: undefined,
    state: undefined,
    postalCode: undefined,
    latitude: rooomBlock.latitude,
    longitude: rooomBlock.longitude,

    description: rooomBlock.note,
    email: undefined,
    phone: undefined,
    url: undefined,

    //   Provider Information
    googlePlaceId: undefined,
    zhId: undefined,

    //   Extra Information
    pricePerNight: rooomBlock.pricePerNight,
    bookingUrl: rooomBlock.bookingUrl,
    cutoffDate: rooomBlock.cutoffDate,
    checkOutDate: rooomBlock.checkOutDate,
    checkInDate: rooomBlock.checkInDate,
    strikeoutPricePerNight: rooomBlock.strikeoutPricePerNight,
    numberOfRoomsBooked: rooomBlock.numberOfRoomsBooked,
    numberOfRoomsGuestBooked: rooomBlock.numberOfRoomsGuestBooked,

    //   Customm Properties
    isFavorite: rooomBlock.isFavorite,
    starRating: rooomBlock.starRating,

    photo: rooomBlock.photo
  } as AccommodationCombined;
};

export const AccommodationPlaceToAccommodationCombined = (accommodationPlace: AccommodationPlaceFragment) => {
  return {
    id: accommodationPlace.id,
    type: accommodationPlace.type === AccommodationPlaceType.hotel ? AccommodationCombinedType.Hotel : AccommodationCombinedType.Custom,

    //   General Information
    displayName: accommodationPlace.joyPlace.name,
    address: accommodationPlace.joyPlace.address,
    city: accommodationPlace.joyPlace.city,
    country: accommodationPlace.joyPlace.country,
    state: accommodationPlace.joyPlace.state,
    postalCode: accommodationPlace.joyPlace.postalCode,
    latitude: accommodationPlace.joyPlace.lat,
    longitude: accommodationPlace.joyPlace.long,

    description: accommodationPlace.userNote,
    email: accommodationPlace.joyPlace.email,
    phone: accommodationPlace.joyPlace.phone,
    url: accommodationPlace.joyPlace.url,

    //   Provider Information
    googlePlaceId: accommodationPlace.joyPlace.googlePlaceId,
    zhId: accommodationPlace.joyPlace.zhId,

    //   Extra Information
    pricePerNight: undefined,
    bookingUrl: undefined,
    cutoffDate: undefined,
    checkOutDate: undefined,
    checkInDate: undefined,
    strikeoutPricePerNight: undefined,
    numberOfRoomsBooked: undefined,
    numberOfRoomsGuestBooked: undefined,

    //   Customm Properties
    isFavorite: undefined,
    starRating: undefined,

    photo: undefined
  };
};

export const sortByFavorite = <T extends HasFavoriteProperty>(list: T[]): T[] => {
  const isFavorite = list?.find(item => item.isFavorite);

  if (isFavorite) {
    const filtered = list?.filter(item => !item.isFavorite);
    return [{ ...isFavorite }, ...filtered];
  }
  return list;
};

export const sortByOrderList = <T extends HasIdProperty>(list: T[], orderList?: string[]): T[] => {
  let orderedList: typeof list = [];
  const listItemMap = new Map(list.map(item => [item.id, item]));
  if (orderList && orderList.length > 0) {
    orderList.forEach(orderId => {
      if (listItemMap.has(orderId)) {
        orderedList.push(listItemMap.get(orderId)!);
        listItemMap.delete(orderId);
      }
    });
    listItemMap.forEach(item => orderedList.push(item));
  } else {
    orderedList = [...list];
  }
  return orderedList?.filter(orderedListItem => orderedListItem !== undefined);
};
